const PALETTE = [
  { name: "violet", border: "border-l-violet-500", dot: "bg-violet-500", text: "text-violet-700", badge: "bg-violet-500/15 text-violet-700 border-violet-500/30" },
  { name: "teal", border: "border-l-teal-500", dot: "bg-teal-500", text: "text-teal-700", badge: "bg-teal-500/15 text-teal-700 border-teal-500/30" },
  { name: "sky", border: "border-l-sky-500", dot: "bg-sky-500", text: "text-sky-700", badge: "bg-sky-500/15 text-sky-700 border-sky-500/30" },
  { name: "emerald", border: "border-l-emerald-500", dot: "bg-emerald-500", text: "text-emerald-700", badge: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30" },
  { name: "fuchsia", border: "border-l-fuchsia-500", dot: "bg-fuchsia-500", text: "text-fuchsia-700", badge: "bg-fuchsia-500/15 text-fuchsia-700 border-fuchsia-500/30" },
  { name: "blue", border: "border-l-blue-500", dot: "bg-blue-500", text: "text-blue-700", badge: "bg-blue-500/15 text-blue-700 border-blue-500/30" },
];

export function getSiteColor(code) {
  const str = code || "SITE";
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) % PALETTE.length;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}
